export enum WorkPackageSortViewEnum {
  Expiration = 'expiration',
  Newest = 'newest',
}
